import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import Field from "@/components/Field";
import FormDialog from "@/components/FormDialog";
import { createBrickSeries } from "../../utils";
import useOrganization from "../../hooks/useOrganization";

interface Props {
  open: boolean;
  onClose(): void;
}

const CreateSeriesModal: React.FC<Props> = ({ open, onClose }) => {
  const organization = useOrganization();
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setName("");
      setError(null);
    }
  }, [open]);

  const handleSubmit = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await createBrickSeries(organization, { name: name.trim() });
      onClose();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <FormDialog
      open={open}
      onOpenChange={(next) => !next && onClose()}
      title="Nieuwe collectie"
      description="Daarna upload je de stenen en een thumbnail."
      submitLabel="Aanmaken"
      submitting={submitting}
      canSubmit={name.trim() !== ""}
      error={error}
      onSubmit={handleSubmit}
    >
      <Field id="series-name" label="Naam">
        <Input
          id="series-name"
          placeholder="Bijvoorbeeld Waalformaat Rood Genuanceerd"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Field>
    </FormDialog>
  );
};

export default CreateSeriesModal;
